import { object2Query, query2Object } from './URLUtils'

/**
 * Função para roteamento de history mantendo querys
 */
export const toRoute = (route, addQuery = null, topRedirect = false) => {
  const location = window.location
  const currentQueryObj = query2Object(location.search)
  let newQuery = currentQueryObj
  // se mudou de rota limpa querys anteriores exceto 'context'
  if (location.pathname.substr(1) !== route) {
    newQuery = ('context' in newQuery) ? {context: newQuery.context} : {}
  }
  if (addQuery) {
    newQuery = {...newQuery, ...addQuery}
  }
  newQuery = object2Query(newQuery)
  if (topRedirect) {
    window.top.location.href = `${process.env.PUBLIC_URL}/${route}${newQuery}`
  } else {
    window.router.push(`${process.env.PUBLIC_URL}/${route}${newQuery}`)
    window.scrollTo(0, 0)
  }
}

/**
 * Altera ou adiciona parâmetros do tipo query string a URL
 *
 * @param {Object} obj
 */
export const changeQuery = (obj) => {
  const location = window.location
  const query = location.search
  const objQuery = query2Object(query)
  for (const key in obj) {
    const value = obj[key]
    objQuery[key] = value
  }
  const newQuery = object2Query(objQuery)
  window.router.push(`${location.pathname}${newQuery}`)
}

/**
 * Remove um determinado parâmetro do tipo query string da URL
 *
 * @param {String} key
 */
export const removeQuery = (key) => {
  const location = window.location
  const query = location.search
  const objQuery = query2Object(query)
  if (key in objQuery) {
    delete objQuery[key]
    const newQuery = object2Query(objQuery)
    window.router.push(`${location.pathname}${newQuery}`)
  }
}

export const redirectSignUpUnimedCeara = (location) => {
  const search = location.search
  const query = query2Object(search)

  let callbackUrl = window.location.origin
  callbackUrl = `${callbackUrl}/public/signin-unimed-ceara?context=${query.context}`

  window.location.href = `https://vcardweb.unimedceara.com.br/register?redirect_uri=${encodeURIComponent(callbackUrl)}`
}

export const redirectForgotPasswordUnimedCeara = (location) => {
  const search = location.search
  const query = query2Object(search)

  let callbackUrl = window.location.origin
  callbackUrl = `${callbackUrl}/public/signin-unimed-ceara?context=${query.context}`

  const href = `https://vcardweb.unimedceara.com.br/recover?redirect_uri=${encodeURIComponent(callbackUrl)}`
  window.location.href = href
}
